import { ExportType } from '@/model';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Button, Icon, Menu, MenuButton, MenuItem, MenuList, forwardRef } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export interface ExportButtonProps {
  onExport?: (exportType: ExportType) => void;
}

export const ExportButton = forwardRef<ExportButtonProps, 'button'>(({ onExport }, ref) => {
  const { t } = useTranslation();

  return (
    <Menu>
      <MenuButton as={Button} variant='link' color='brand.500' leftIcon={<Icon as={ExternalLinkIcon} />} ref={ref}>
        {t('components.table_simple_controls.export_button_label')}
      </MenuButton>

      <MenuList>
        <MenuItem onClick={() => onExport?.(ExportType.XLSX)}>
          {t('components.table_simple_controls.export_button_excel_option')}
        </MenuItem>
        <MenuItem onClick={() => onExport?.(ExportType.CSV)}>
          {' '}
          {t('components.table_simple_controls.export_button_csv_option')}
        </MenuItem>
      </MenuList>
    </Menu>
  );
});
